<template>
  <div class="container" >
    <NavComponent/>
       <div class="elemnts">
           <div class="menu">
    <router-link to="/graficomentoria">
  <img src="@/assets/B1.png" alt="Botão" />
</router-link>
       </div>

        <div class="menu">
            <router-link to="/coachee">
         <img src="@/assets/B2.png" alt="" srcset="">
         </router-link>
       </div>


    <div class="menu">
         <router-link to="/coach">
         <img src="@/assets/B3.png" alt="" srcset="">
         </router-link>
       </div>



        <div class="menu">
             <router-link to="/reagendadas">
         <img src="@/assets/B4.png" alt="" srcset="">
         </router-link>
       </div>
         
 
   <div class="menu" >
            <router-link to="/BusinessPartners">
         <img src="@/assets/B6.png" alt="" srcset="">
         </router-link>
       </div>
       </div>
              <div class="menu" >
            <router-link to="/utilizadores">
         <img src="@/assets/B5.png" alt="" srcset="">
         </router-link>
       </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import NavComponent from '@/components/navComponent.vue';



const userTipoRaw = localStorage.getItem('userTipo') || ''
const userTipo = ref(userTipoRaw.replace(/['"]+/g, ''))
</script>

<style scoped>
.container{
    width: 100%;
      
}
.elemnts {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-top: 6%;
  gap: 2%; /* espaçamento horizontal e vertical entre os menus */
}

.menu{
    width: 15%;
    margin-right: auto;
    margin-bottom: 2%;
}
.menu img{
    width: 100%;
    padding-left: 10%;
    cursor: pointer;

}
</style>